// extracted by mini-css-extract-plugin
export var budget = "RangeSlider-module--budget--4fd97";
export var container = "RangeSlider-module--container--02320";
export var duration = "RangeSlider-module--duration--e81e1";
export var fadeInAnimation = "RangeSlider-module--fadeInAnimation--b1ee5";
export var slider = "RangeSlider-module--slider--88bb0";
export var tooltip = "RangeSlider-module--tooltip--1c9bb";
export var tooltipValue = "RangeSlider-module--tooltipValue--6f85d";